/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2021-05-06 14:17:58
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2021-06-23 12:16:53
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\newPatientmanage\api\treatmentPlan.js
 */

import request from '@/utils/req.js';

//患者诊疗事件列表分页条件查询
export function apiArchivesEvent(params) {
    return request.get("/admin/archives-event/page", params);
}
//根据诊疗事件ID  获取 当天所有事件
export function apiArchivesEventDetail(params) {
    return request.get("/admin/archives-event/detail", params);
}
//诊疗事件列表
export function apiArchivesEventList(params) {
    return request.get("/admin/archives-event/list", params);
}

//删除诊疗事件
export function apiDeleteArchives(id) {
    return request.delete(`/admin/archives-event/${id}`);
}

//新增诊疗事件
export function apiAddArchives(params) {
    return request.post("/admin/archives-event/add", params);
}
//编辑诊疗事件
export function apiUpdateArchives(params) {
    return request.post("/admin/archives-event/updateArchives", params);
}

//任务提醒模块=================================================================

//个案任务提醒列表
export function apiGetTaskRemberList(params) {
    return request.post(`/admin/case-mgr-task/getByWholeCourseId?wholeCourseId=${params}`);
}
//任务提醒标记完成 
export function apiPutTaskOver(params) {
    return request.put("/admin/case-mgr-task", params);
}
//打卡异常列表
export function apiGetPatientPunchList(params, e) {
    return request.post(`/admin/patient-task/getByWholeCourseId?wholeCourseId=${params}&status=${e}`);
}
//推送提醒
export function apiGetPushRedmind(params) {
    return request.get("/admin/patient-task/redmind", params);
}

//反馈处理列表
export function apiGetfeedbackList(params) {
    return request.get("/admin/feedback/getByWholeCourseId", params);
}
// 客服取消处理
export function feedbackStatusCovert(params) {
    return request.put("/admin/feedback/feedbackStatusCovert", params)
}

// 判断当前患者是否为客服
export function judgeIsCustomer(params) {
    return request.get(`/admin/department-member/isCustomer/${params}`, {})
}
//报告处理展示问卷
export function feedbckStatusUpdate(params) {
    return request.put("/admin/feedback/feedbckstatusupdate", params)
}
//报告处理展示问卷
export function selectListExam(params) {
    return request.get("/admin/qs-answer-sheet/getAnswerSheetLog", params)
}
//对照录入列表
export function apiGetPatientFiles(params) {
    return request.get(`/admin/patient-files-item/getByWholeCourseId?wholeCourseId=${params}`)
}

//患者不良事件列表分页接口
export function apiAddArchivesList(params) {
    return request.post("/admin/adverse-event/page", params);
}
//事件删除
export function apideleteEvent(params) {
    return request.delete(`/admin/adverse-event/${params}`)
}
//事件修改
export function apiuploadEvent(params) {
    return request.put("/admin/adverse-event", params)
}
//添加不良事件
export function apiAddAdverseEvent(params) {
    return request.post("/admin/adverse-event", params)
}
//获取上报科室接口
export function apiPlatform_department(params) {
    return request.post("/admin/platform-department/list", params)
}

//关联病历事件时下拉选项，参数传patientId
export function getArchivesList(params) {
    return request.get("/admin/archives-event/options", params)
}

//医院列表查询
export function getHospitalList(params) {
    return request.get("/admin/hospital", params)
}

//标准科室选择列表
export function getDepartmentList(params) {
    return request.post("/admin/standard-department/select", params)
}

// 对照录入保存2.0
export function saveContent(params) {
    return request.post("/admin/patient-files", params)
}

// 用药频率
export function getFrequency(params) {
    return request.get("admin/category/medication_frequency/children", params)
}
// 单位
export function getSpecs(params) {
    return request.get("admin/category/drug_specs/children", params)
}
// 用药途径
export function getRoute(params) {
    return request.get("admin/category/route_of_administration/children", params)
}

// 运动类型
export function getMoveType(params) {
    return request.post("admin/standard-category/list", params)
}
// 运动项目
export function getMoveItem(params) {
    return request.post("/admin/movement-info/list", params)
}
// 治疗项目列表查询
export function getTreatmentList(params) {
    return request.post("/admin/treatment-item/list", params)
}

// 商户药品信息录入表列表查询
export function getDrugList(params) {
    return request.get("admin/drug", params)
}

// 个案使用对照录入保存的就诊地点列表查询
export function getPlaceList(params) {
    return request.post("/admin/case-mgr-place/list", params)
}

//根据事件id查询事件下关联数据的相关信息
export function getArchivesEventLog(params) {
    return request.get(`/admin/archives-event/getArchivesEventByArchivesId/${params}`)
}

// 根据患者id获取患者购买服务的下拉列表
export function getSchemeNameByPatientId(params) {
    return request.get(`/admin/whole-course/getSchemeNameByPatientId`, params)
}

// 用药记录接口
export function getPatientTakeDrugsRecordVOByPatientId(param) {
    return request.get(`/admin/take-drugs-record/getPatientTakeDrugsRecordVOByPatientId`, param)
}

// 患者用药记录详情
export function getPatientTakeDrugsDetail(id) {
    return request.get(`/admin/take-drugs-record/${id}`)
}

// 获取运营任务列表 
export function getOperationTaskYearMonthDayVOByPatientId(patientId) {
    return request.get(`/admin/operation-task/getOperationTaskYearMonthDayVOByPatientId/${patientId}`)
}

// 运营任务新增接口
export function addOperationTaskAndPatientTodo(params) {
    return request.post("/admin/operation-task/addOperationTaskAndPatientTodo", params)
}

// 运营任务详情接口
export function getOperationTaskDetail(id) {
    return request.get(`/admin/operation-task/${id}`)
}

// 运营任务编辑接口 
export function updateOperationTaskAndPatientTodo(params) {
    return request.post("/admin/operation-task/updateOperationTaskAndPatientTodo", params)
}

// 运营任务删除接口
export function deleteOperationTaskAndPatientTodo(id) {
    return request.delete(`/admin/operation-task/deleteOperationTaskAndPatientTodo/${id}`)
}

// 及时反馈-发送 
export function sendFeedbackReport(refId, channel) {
    var url = `/admin/feedback-report/sendFeedbackReport?refId=${refId}`
    if (channel) {
        url += `&channel=${channel}`
    }
    return request.post(url)
}

// 及时反馈-任务删除
export function deleteCaseMgrTask(id) {
    return request.delete(`/admin/case-mgr-task/${id}`)
}

// 及时反馈-添加/修改患者反馈报告表
export function saveOrUpdateFeedbackReport(params) {
    return request.post("/admin/feedback-report/saveOrUpdate", params)
}

// 及时反馈-详情
export function getFeedbackReportDetail(id) {
    return request.get(`/admin/feedback-report/${id}`)
}
// 患者记录配置
export function getPatientRecords(params) {
    return request.get(`/admin/disease-patient-record/getPatientRecordsByPatientId`, params)
}

//根据检验名称模糊分页搜索检验详情数据
export function getInspectionInfoPageByName(params) {
    return request.post("/admin/inspection-info/getInspectionInfoPageByName", params)
}

// 诊疗事件左侧
export function getArchivesEventByPatientId(params) {
    // return request.post("/admin/archives-event/getArchivesEventByPatientId", params)
    return request.post("/admin/archives-event/getNewArchivesEventByPatientId", params)
}
// 诊疗事件右侧
export function getPatientArchivesEventByPatientId(params) {
    return request.post("/admin/archives-event/getNewPatientArchivesEventByPatientId", params)
}
// 诊疗事件右侧所有事件
export function getPatientEventDetailByPatientIdAndType(params) {
    return request.post("/admin/archives-event/getNewPatientEventDetailByPatientIdAndType", params)
}

// // 诊疗计划 住院记录
// export function getInHospitalEvent(params) {
//     return request.post("/admin/archives-event/getInHospitalEvent", params)
// }

// 诊疗计划 住院记录
export function getInHospitalEvent(params) {
  return request.post("/admin/archives-event/getNewInHospitalEvent", params)
}

export function finishPatientTodoTask(params) {
  return request.get("/dsicm-api/feign/patient-todo-task/finish", params)
}

export function callTemplate(templateId, params) {
  return request.get(`/biz/feedback-template/callTemplate/${templateId}`, params)
}

export function getHistoryCaseMgrTaskV2VOByPatientId(params) {
  return request.post(`/admin/patient/getHistoryCaseMgrTaskV2VOByPatientId`, params)
}

